import { colors } from 'ui/theme/colors';
import { getColor } from '../../utils';
import { SvgIcon, SvgIconProps } from '../../SvgIcon';

export const Exit24 = ({
  height = 24,
  width = 24,
  color = colors.iconPrimary,
  isColorInherited = false,
  ...props
}: SvgIconProps) => (
  <SvgIcon data-temporary-fix height={height} width={width} viewBox="0 0 24 24" {...props}>
    <path
      d="M18.364 5.36396C18.7355 5.73548 18.7355 6.33784 18.364 6.70936L13.3454 11.7279L18.364 16.7465C18.7355 17.118 18.7355 17.7204 18.364 18.0919C17.9924 18.4634 17.3901 18.4634 17.0186 18.0919L12 13.0733L6.98144 18.0919C6.60992 18.4634 6.00756 18.4634 5.63604 18.0919C5.26452 17.7204 5.26452 17.118 5.63604 16.7465L10.6546 11.7279L5.63604 6.70936C5.26452 6.33784 5.26452 5.73548 5.63604 5.36396C6.00756 4.99244 6.60992 4.99244 6.98144 5.36396L12 10.3825L17.0186 5.36396C17.3901 4.99244 17.9924 4.99244 18.364 5.36396Z"
      fillRule="evenodd"
      clipRule="evenodd"
      fill={getColor(color, isColorInherited)}
    />
  </SvgIcon>
);
